import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import UserManagementApiService from 'client/utils/clientApiHelper'
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';
import { ADD_EMPLOYEE_TO_COST_CENTER, GET_EMPLOYEES_WITH_HOME_COST_CENTER_LIST, GET_USERS_BY_SEARCH_TEXT } from 'Store/Identity/UserBySearchText/UserBySearchTextType';
import { setEmployeesWithHomeCostCenterList, setIsEmployeeAddedToCostCenter, setUserFilterBySearchText } from 'Store/Identity/UserBySearchText/UserBySearchTextAction';

function* getUsersBysearchTextSaga(data: any): any {
    try {
        yield put(globalLoaderText("Fetching Users Data...."));
        let payloadData: IPayload = {
            apiType: apiType.Identity,
            endpoint: `user/asssetinventory/filter/${data?.payload}`,
            apiMethod: apiMethod.GET,
            payload: null
        }
        const response = yield call(
            UserManagementApiService.callUserPost, API_URL.PostWebApp, payloadData
        );
        if (response) {
            yield put(setUserFilterBySearchText(response));
            yield put(globalLoaderText(""));
        }

    } catch (error) {
        yield put(setUserFilterBySearchText([]))
        yield put(globalLoaderText(""));
    }
}

function* AddEmployee(data: any): any {
    try {
        yield put(globalLoaderText("Saving Users Data...."));
        let payloadData: IPayload = {
            apiType: apiType.AssetManagement,
            endpoint: `asssetinventory/costcenter/user`,
            apiMethod: apiMethod.POST,
            payload: data.payload
        }
        const response = yield call(
            UserManagementApiService.callUserPost, API_URL.PostWebApp, payloadData
        );
        if(response){
            yield put(setIsEmployeeAddedToCostCenter('added'));
        } else {
            yield put(setIsEmployeeAddedToCostCenter('exists'));
        }
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setIsEmployeeAddedToCostCenter('error'))
        yield put(globalLoaderText(""));
    }
}

function* getEmployeesWithHomeCostCenters(data: any): any {
    try {
        yield put(globalLoaderText("Fetching Users Data...."));
        let payloadData: IPayload = {
            apiType: apiType.Identity,
            endpoint: `user/asssetinventory/${data?.payload}`,
            apiMethod: apiMethod.GET,
            payload: null
        }
        const response = yield call(
            UserManagementApiService.callUserPost, API_URL.PostWebApp, payloadData
        );
            yield put(setEmployeesWithHomeCostCenterList(response));
            yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setEmployeesWithHomeCostCenterList([]))
        yield put(globalLoaderText(""));
    }
}

function* watchRegion() {
    yield takeEvery(GET_USERS_BY_SEARCH_TEXT, getUsersBysearchTextSaga);
    yield takeEvery(ADD_EMPLOYEE_TO_COST_CENTER, AddEmployee);
    yield takeEvery(GET_EMPLOYEES_WITH_HOME_COST_CENTER_LIST, getEmployeesWithHomeCostCenters);
}

export default function* combinedSaga() {
    yield all([
        watchRegion()
    ])
}